import { render, staticRenderFns } from "./urunler.vue?vue&type=template&id=1c053662&scoped=true&"
import script from "./urunler.vue?vue&type=script&lang=js&"
export * from "./urunler.vue?vue&type=script&lang=js&"
import style0 from "./urunler.vue?vue&type=style&index=0&id=1c053662&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c053662",
  null
  
)

export default component.exports